/** The iPad injects this copied script as a WKUserScript and adds two actions
 * in its native menu. Adapt only that host surface; retain the original DOM
 * selection, UTF-16 source mapping, multi-selection and overlay lifecycle. */
export function adaptSelectionMenu(source: string, presentation: 'conversation' | 'document' = 'conversation'): string {
  const handler = '__CHAT_TRANSCRIPT_SELECTION_CONTEXT_MENU_HANDLER_NAME__';
  const add = "selectedTextOverlayElement.appendChild(makeSelectedTextOverlayButton('add', '添加到对话', 'addToChat'));";
  const side = "selectedTextOverlayElement.appendChild(makeSelectedTextOverlayButton('ask', '侧聊', 'askInSideChat'));";
  const context = 'postSelectionContextMenuPayload(payload);\n  }, true);\n})();';
  for (const marker of [handler, add, side, context]) {
    if (source.split(marker).length !== 2) throw new Error('聊天选区菜单资源与宿主适配不匹配');
  }
  return source.replace(handler, 'readosSelectionAction')
    .replace(add, presentation === 'document' ? '' : add + "\n    selectedTextOverlayElement.appendChild(makeSelectedTextOverlayButton('detail', '更多详情', 'quickChatDetail'));")
    .replace(side, (presentation === 'document' ? '' : side) + "\n    selectedTextOverlayElement.appendChild(makeSelectedTextOverlayButton('copy', '拷贝', 'copySelection'));")
    .replace(context, 'postSelectionContextMenuPayload(payload);\n    scheduleSelectedTextOverlayRender();\n  }, true);\n})();');
}
